import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB0PSIxNzQ0NjA4OTg4NzYzIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExMjE2IiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZiI+PHBhdGggZD0iTTk2IDY0aDgzMmEzMiAzMiAwIDEgMSAwIDY0aC04MzJhMzIgMzIgMCAwIDEgMC02NHogbTAgMzg0aDM4NGEzMiAzMiAwIDAgMSAwIDY0aC0zODRhMzIgMzIgMCAwIDEgMC02NHogbTAgMzg0aDM4NGEzMiAzMiAwIDEgMSAwIDY0aC0zODRhMzIgMzIgMCAxIDEgMC02NHogbTc5NC4zNjgtMzM3LjUzNmwtMjU4LjQzMiAxNzIuMjg4YTQ0LjggNDQuOCAwIDAgMCAwIDc0LjQ5NmwyNTguNDMyIDE3Mi4yODhBNDQuOCA0NC44IDAgMCAwIDk2MCA4NzYuMjg4VjUzMS43MTJhNDQuOCA0NC44IDAgMCAwLTY5LjYzMi0zNy4yNDh6IiBwLWlkPSIxMTIxNyI+PC9wYXRoPjwvc3ZnPg==)
 */
export const MenuCloseIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, ...props }, forwardedRef) => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M96 64h832a32 32 0 1 1 0 64h-832a32 32 0 0 1 0-64z m0 384h384a32 32 0 0 1 0 64h-384a32 32 0 0 1 0-64z m0 384h384a32 32 0 1 1 0 64h-384a32 32 0 1 1 0-64z m794.368-337.536l-258.432 172.288a44.8 44.8 0 0 0 0 74.496l258.432 172.288A44.8 44.8 0 0 0 960 876.288V531.712a44.8 44.8 0 0 0-69.632-37.248z"
          fill={color}
        ></path>
      </svg>
    )
  },
)
